import { Toast } from 'antd-mobile'
import appConfig from '@/config'
import { isAndroid, isChrome } from './platformHelper'

export const pxTransform = (size: string | number) => {
  const designWidth = +(process as any).env.REACT_APP_designWidth
  return (
    Math.ceil((((parseInt(`${size}`, 10) / 40) * 640) / designWidth) * 10000) /
      10000 +
    'rem'
  )
}

/**
 * 获取指定的url查询参数值
 * @param {string} pname 参数名称
 * @param {string} purl url地址，默认为当前url地址
 */
export function getParameterByName(pname: string, purl?: string): any {
  let name = pname
  let url = purl

  if (!url) url = window.location.href

  name = name.replace(/[[\]]/g, '\\$&')

  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`)
  const results = regex.exec(url)

  if (!results) return null
  if (!results[2]) return ''

  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

export function updateQueryStringParameter(
  uri: string,
  key: string,
  value: string,
) {
  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i')
  var separator = uri.indexOf('?') !== -1 ? '&' : '?'
  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + value + '$2')
  } else {
    return uri + separator + key + '=' + value
  }
}

export function ToastFail(
  content = '',
  duration = 1,
  onClose = () => {},
  mask = false,
) {
  Toast.fail(content, duration, onClose, mask)
}

export function ToastSuccess(
  content = '',
  duration = 1,
  onClose = () => {},
  mask = false,
) {
  Toast.success(content, duration, onClose, mask)
}

export function disableUserScalable() {
  window.onload = function() {
    document.addEventListener('touchstart', function(event) {
      if (event.touches.length > 1) {
        event.preventDefault()
      }
    })
    let lastTouchEnd = 0
    document.addEventListener(
      'touchend',
      function(event) {
        const now = new Date().getTime()
        if (now - lastTouchEnd <= 300) {
          event.preventDefault()
        }
        lastTouchEnd = now
      },
      false,
    )
    document.addEventListener('gesturestart', function(event) {
      event.preventDefault()
    })
  }
}

export function listenVirtualkeyboardAction() {
  window.onload = function() {
    if (!isAndroid()) return
    if (isChrome()) return

    const originHeight =
      document.documentElement.clientHeight || document.body.clientHeight
    window.addEventListener(
      'resize',
      () => {
        const resizeHeight =
          document.documentElement.clientHeight || document.body.clientHeight
        if (resizeHeight < originHeight) {
          // 键盘弹起
          console.log('键盘弹起')
        } else {
          // 键盘收起
          console.log('键盘收起')
          const input: any = document.querySelector('.search-bar-wrap input')
          input && input.blur()
        }
      },
      false,
    )
  }
}

export function formatSecondsToMinutes(val: number) {
  const translationVal = (val: number) => (val < 10 ? `0${val}` : val)

  if (val < 60) {
    return `00:${translationVal(val)}`
  }

  const m = Math.floor(val / 60)
  const s = val % 60

  return `${translationVal(m)}:${translationVal(s)}`
}

export function getDefaultExport(module: any) {
  return module && module.__esModule ? module['default'] : module
}

export function initVconsole() {
  if (!appConfig.REACT_APP_debug) return
  import('vconsole').then(module => {
    const Vconsole = getDefaultExport(module)
    new Vconsole()
  })
}

/**
 * 计算剩余时间
 * @param open_time 开始时间
 * @param duration_time 持续时间
 * @returns
 */
export function getRemainingTime(open_time: string, duration_time: string) {
  const now = Math.floor(Date.now() / 1000) // 获取当前时间戳，注意单位为毫秒，需要转换为秒
  const elapsed_time = now - Number(open_time) // 已经过去的时间
  const remaining_time = Number(duration_time) - elapsed_time // 剩余时间
  if (remaining_time <= 0) {
    // 如果剩余时间小于0，表示已经结束
    return 0
  }
  return remaining_time
}

export function formatRemainingTime(remaining_time: number) {
  const hours = Math.floor(remaining_time / 3600) // 剩余小时数
  const minutes = Math.floor((remaining_time % 3600) / 60) // 剩余分钟数
  const seconds = remaining_time % 60 // 剩余秒数
  // 将时钟显示格式改为24小时制
  const formattedHours = hours < 10 ? `0${hours}` : `${hours}`
  // 将分钟显示格式改为两位数
  const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`
  // 将秒钟显示格式改为两位数
  const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`
  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
}

export function isBackendPath(path: string) {
  return path.startsWith('backend')
}
